import React, { useEffect, useState } from "react"
import { Card, CardBody } from "reactstrap"
import { useClientContext } from "../ClientContextBox"
import { validateContact } from "helpers/common_helper"
import { axiosbaseurl } from "configure"
import LoadingButton from "components/Common/LoadingButton"
import ClientInvoices from "./ClientInvoices"
import Select from "react-select"
import { customStyles } from "helpers/select-styles"

const ServiceBilling = ({ changeStep, client_id }) => {
  const {
    errors,
    setErrors,
    isReadOnly,
    invoicing_options,
    payment_options,
    clientType,
    clientName,
    clientId,
    invoiceMethod,
    setInvoiceMethod,
    paymentMethod,
    setPaymentMethod,
    monthlyOverride,
    setMonthlyOverride,
    servicesCalculation,
    setServicesCalculation,
    xeroContactDetails,
    tags,

    setIsChanged,
  } = useClientContext()

  const [loading, setLoading] = useState(false)
  const [grandTotal, setGrandTotal] = useState(0)
  const [available_services, setavailable_services] = useState([])

  useEffect(() => {
    // for final services
    let services = servicesCalculation.filter(
      item => item.clientType == clientType || item.clientType === 0
    )

    // console.log(servicesCalculation, services)

    setavailable_services(services)

    // for grand total
    services = services?.filter(item => item.isChecked)
    setGrandTotal(services.reduce((acc, curr) => acc + curr.total, 0))
  }, [servicesCalculation])

  // for service calculations
  const handleCheckboxChange = service_id => {
    const updatedServices = [...servicesCalculation]

    setServicesCalculation(
      updatedServices.map(item => {
        if (item.id === service_id) {
          item.isChecked = !item.isChecked
          item.price = 0
          item.discount = 0
          item.total = 0
        }
        return item
      })
    )
  }

  const handleInputChange = (service_id, field, value) => {
    const updatedServices = [...servicesCalculation]
    setServicesCalculation(
      updatedServices.map(item => {
        if (item.id === service_id) {
          item[field] = Number(value)
          item.total = item.price - (item.price * item.discount) / 100
        }
        return item
      })
    )
  }

  // =======================

  // ==================== NEW: Handle Service Tags ====================
  const handleTagChange = (service_id, selectedTags) => {
    const selectedTagIds = selectedTags
      ? selectedTags.map(tag => tag.value)
      : []

    setServicesCalculation(prev =>
      prev.map(item =>
        item.id === service_id
          ? { ...item, tagIds: selectedTagIds } // Store tag IDs in service
          : item
      )
    )

    setIsChanged(prev => ({ ...prev, 2: true }))
  }

  // Convert tagIds back to react-select format for display
  const getSelectedTags = service => {
    if (!service.tagIds || !tags) return []
    return service.tagIds
      .map(id => tags.find(tag => tag.value === id))
      .filter(Boolean)
  }

  // const c_type = client_type_options?.find(item => item.id === Number(clientType))?.clientType;

  const validate = () => {
    let tempErrors = {}
    if (!invoiceMethod) tempErrors.invoiceMethod = "Invoice Method is required."
    if (!paymentMethod) tempErrors.paymentMethod = "Payment Method is required."

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  // saving data
  const handleSubmit = async () => {
    if (validate() && !isReadOnly) {
      // if (true) {

      const services = servicesCalculation?.filter(
        item =>
          item.isChecked &&
          (item.clientType == clientType || item.clientType === 0)
      )

      // if (services.some(s => ['', null].includes(s.price))) {
      //   swal("", "Incomplete Service details.", "warning")
      //   return;
      // }

      // validate services
      // if (services.some(item => !item.price)) {
      //   swal("", "Please fillout selected service details", "warning")
      //   return
      // }

      swal({
        title: "Are you sure?",
        text: `You want to save this details to ${clientName}.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async willDelete => {
        if (willDelete) {
          try {
            setLoading(true)

            const post_data = {
              invoicingMethodId: invoiceMethod,
              paymentMethodId: paymentMethod,
              serviceNameId: JSON.stringify(services),
              grandTotal,
              monthlyOverride,
            }

            const response = await axiosbaseurl.put(
              `/client/${clientId || client_id}`,
              post_data
            )

            if (response.data.success) {
              // setClientId(response.data.data.id)
              setIsChanged(prev => ({ ...prev, 2: false }))
              swal("", "Details saved successfully", "success").then(() => {
                changeStep()
              })
            }
          } catch (error) {
            console.log(error)
            const msg =
              error.response.data.message ||
              error.message ||
              "Something went Wrong"

            swal(
              "",
              msg,
              msg.includes("No changes were made !") ? "warning" : "error"
            )
          } finally {
            setLoading(false)
          }
        }
      })
    } else window.scrollTo(0, 100)
  }

  const serviceCategories = [
    "Billiable and scheduled",
    "Billiable and Non-scheduled",
  ]

  return (
    <div>
      <Card>
        <CardBody>
          <div className="row mb-3 pb-3 border-bottom border-dark">
            <h4 className="fw-bold mb-4">Services & Billing</h4>

            <div className="col-md-4 mb-3">
              <label>
                Invoicing Method <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field"
                disabled={isReadOnly}
                value={invoiceMethod}
                onChange={e => setInvoiceMethod(e.target.value)}
              >
                <option value="">Select Invoicing method</option>
                {invoicing_options
                  ?.slice()
                  .sort((a, b) =>
                    a.invoicingMethod.localeCompare(b.invoicingMethod)
                  )
                  ?.map(option => (
                    <option key={option.id} value={option.id}>
                      {option.invoicingMethod}
                    </option>
                  ))}
              </select>
              <span className="error">{errors.invoiceMethod}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Payment Method <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field"
                disabled={isReadOnly}
                value={paymentMethod}
                onChange={e => setPaymentMethod(e.target.value)}
              >
                <option value="">Select Payment Method</option>
                {payment_options
                  ?.slice()
                  .sort((a, b) =>
                    a.paymentMethod.localeCompare(b.paymentMethod)
                  )
                  ?.map(option => (
                    <option key={option.id} value={option.id}>
                      {option.paymentMethod}
                    </option>
                  ))}
              </select>
              <span className="error">{errors.paymentMethod}</span>
            </div>

            <div className="col-md-12 mt-3">
              <h4 className="fw-bold mb-4">Xero Contact Details</h4>
              <div>
                <table className="table">
                  <tbody>
                    {/* <tr>
                      <th>contact ID</th>
                      <td>{xeroContactDetails?.contactID}</td>
                    </tr> */}
                    <tr>
                      <th className="col-2">Full Name</th>
                      <td>{xeroContactDetails?.name}</td>
                    </tr>
                    <tr>
                      <th>Email Address</th>
                      <td>{xeroContactDetails?.emailAddress}</td>
                    </tr>
                    <tr>
                      <th>Contact Status</th>
                      <td>{xeroContactDetails?.contactStatus}</td>
                    </tr>
                    <tr>
                      <th>Address</th>
                      <td>{xeroContactDetails?.addresses}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* JRBRPWR-153 */}
          <div className="row mb-3 pt-3">
            <h4 className="fw-bold mb-4">Billable and Scheduled</h4>
            <div className="col-12 mb-3">
              <table
                className="table text-center"
                style={{ verticalAlign: "middle" }}
              >
                <thead className="table-primary">
                  <tr>
                    <th>Service</th>
                    <th>Tags</th>
                    <th>Price (£)</th>
                    <th>Discount (%)</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {available_services
                    ?.filter(ser => ser.category == serviceCategories[0])
                    ?.map(service => {
                      const selectedTags = getSelectedTags(service)
                      const filteredTagOptions = tags.filter(tag =>
                        tag.serviceIds.includes(service.id)
                      )
                      return (
                        <tr key={service.id}>
                          <td className="col-4">
                            <div className="form-control input-field">
                              <div className="form-check form-check-success pt-0">
                                <input
                                  type="checkbox"
                                  className="form-check-input border-primary fs-5"
                                  disabled={isReadOnly}
                                  id={service.name}
                                  checked={service.isChecked}
                                  onChange={() =>
                                    handleCheckboxChange(service.id)
                                  }
                                />
                                <label
                                  htmlFor={service.name}
                                  className="form-check-label w-100"
                                >
                                  {service.name}
                                </label>
                              </div>
                            </div>
                          </td>
                          <td className="col-4">
                            <Select
                              value={selectedTags}
                              onChange={selected =>
                                handleTagChange(service.id, selected)
                              }
                              options={filteredTagOptions}
                              styles={customStyles}
                              isMulti
                              isDisabled={isReadOnly || !service.isChecked}
                              placeholder="Select tags..."
                              closeMenuOnSelect={false}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={service.price || ""}
                              disabled={!service.isChecked || isReadOnly}
                              onChange={e =>
                                handleInputChange(
                                  service.id,
                                  "price",
                                  e.target.value
                                )
                              }
                              placeholder="0"
                              className="form-control input-field mx-auto text-center price-discount-input"
                              style={{ width: "100px" }}
                              onKeyDown={validateContact}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={service.discount || ""}
                              disabled={!service.isChecked || isReadOnly}
                              onChange={e =>
                                handleInputChange(
                                  service.id,
                                  "discount",
                                  e.target.value
                                )
                              }
                              placeholder="0"
                              className="form-control input-field mx-auto text-center price-discount-input"
                              style={{ width: "100px" }}
                              onKeyDown={validateContact}
                            />
                          </td>
                          <td>
                            <div className="fs-5 fw-semibold text-nowrap">
                              £ {service.total.toFixed(2)}
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row mb-3 pt-3">
            <h4 className="fw-bold mb-4">Billable and Non-Scheduled</h4>
            <div className="col-12 mb-3">
              <table
                className="table text-center"
                style={{ verticalAlign: "middle" }}
              >
                <thead className="table-primary">
                  <tr>
                    <th>Service</th>
                    <th>Tags</th>
                    <th>Price (£)</th>
                    <th>Discount (%)</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {available_services
                    ?.filter(ser => ser.category == serviceCategories[1])
                    ?.map(service => {
                      const selectedTags = getSelectedTags(service)
                      const filteredTagOptions = tags.filter(tag =>
                        tag.serviceIds.includes(service.id)
                      )
                      return (
                        <tr key={service.id}>
                          <td className="col-4">
                            <div className="form-control input-field">
                              <div className="form-check form-check-success pt-0">
                                <input
                                  type="checkbox"
                                  className="form-check-input border-primary fs-5"
                                  disabled={isReadOnly}
                                  id={service.name}
                                  checked={service.isChecked}
                                  onChange={() =>
                                    handleCheckboxChange(service.id)
                                  }
                                />
                                <label
                                  htmlFor={service.name}
                                  className="form-check-label w-100"
                                >
                                  {service.name}
                                </label>
                              </div>
                            </div>
                          </td>
                          <td className="col-4">
                            <Select
                              value={selectedTags}
                              onChange={selected =>
                                handleTagChange(service.id, selected)
                              }
                              options={filteredTagOptions}
                              styles={customStyles}
                              isMulti
                              isDisabled={isReadOnly || !service.isChecked}
                              placeholder="Select tags..."
                              closeMenuOnSelect={false}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={service.price || ""}
                              disabled={!service.isChecked || isReadOnly}
                              onChange={e =>
                                handleInputChange(
                                  service.id,
                                  "price",
                                  e.target.value
                                )
                              }
                              placeholder="0"
                              className="form-control input-field mx-auto text-center price-discount-input"
                              style={{ width: "100px" }}
                              onKeyDown={validateContact}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              value={service.discount || ""}
                              disabled={!service.isChecked || isReadOnly}
                              onChange={e =>
                                handleInputChange(
                                  service.id,
                                  "discount",
                                  e.target.value
                                )
                              }
                              placeholder="0"
                              className="form-control input-field mx-auto text-center price-discount-input"
                              style={{ width: "100px" }}
                              onKeyDown={validateContact}
                            />
                          </td>
                          <td>
                            <div className="fs-5 fw-semibold text-nowrap">
                              £ {service.total.toFixed(2)}
                            </div>
                          </td>
                        </tr>
                      )
                    })}

                  <tr>
                    <td colSpan={3} className="text-end">
                      <div className="fs-5 fw-semibold">Total Amount :</div>
                    </td>
                    <td>
                      <div className="fs-5 fw-semibold">
                        £ {grandTotal.toFixed(2)}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-md-4 mb-3">
              <label>Monthly Override</label>
              <input
                type="number"
                placeholder="Monthly Override"
                disabled={isReadOnly}
                value={monthlyOverride}
                onChange={e => setMonthlyOverride(e.target.value)}
                className="form-control input-field"
              />
            </div>

            <div className="col-md-8  pt-4 mt-2">
              {!isReadOnly ? (
                <LoadingButton
                  loading={loading}
                  btnText="Save & Next"
                  icon_2={<i className="fas fa-arrow-right ms-3"></i>}
                  handler={handleSubmit}
                />
              ) : null}
            </div>
          </div>
        </CardBody>
      </Card>

      <ClientInvoices client_id={client_id} />
    </div>
  )
}

export default ServiceBilling
